<template>
    <div class="p-fluid mt-3">
        <h5>Apply To Join</h5>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Nama Bank</label>
            <div class="col-12 md:col-10">
                <Dropdown v-model="form.bank_id" :options="banks" option-label="name" option-value="id"
                    placeholder="Select Bank" :class="{ 'p-invalid': submitted && !form.bank_id }"></Dropdown>
                <small class="p-invalid" v-if="submitted && !form.bank_id">{{ $t('bank') }} is required.</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Nama Rekening</label>
            <div class="col-12 md:col-10">
                <InputText id="name" type="text" required="true" v-model="form.account_name" :class="{
                    'p-invalid':
                        submitted && !form.account_name,
                }" />
                <small class="p-invalid" v-if="submitted && !form.account_name">Nama Rekening Perlu Diisi</small>
            </div>
        </div>
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Nomor Rekening</label>
            <div class="col-12 md:col-10">
                <InputText id="name" type="text" required="true" v-model="form.account_number" :class="{
                    'p-invalid':
                        submitted && !form.account_number,
                }" />
                <small class="p-invalid" v-if="submitted && !form.account_number">Nomor Rekening Perlu Diisi</small>
            </div>
        </div>
    </div>
</template>
<script>
import { usePage } from "@inertiajs/inertia-vue3";
import axios from 'axios';
import InputText from 'primevue/inputtext';
import Dropdown from "primevue/dropdown";

export default {
    components:{
        InputText,
        Dropdown,
    },
    props: ['applicant'],
    data(){
        return {
            model: {},
            form: {
                applicant_id: this.applicant.id,
            },
            banks: "",
        }
    },
    mounted(){
        this.initData();
    },
    methods:{
        initData(){
            axios.get(`${this.$page.props.appUrl}api/banks`)
                .then((data) => {
                    this.banks = data.data.data
                });
        },
    }
}

</script>
